import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, CheckCircle, XCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AppointmentsAdmin() {
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const { data } = await axios.get(`${API}/api/admin/appointments`, { withCredentials: true });
      setAppointments(data);
    } catch (err) {
      toast.error('Randevular yüklenemedi');
    }
  };

  const handleStatus = async (id, status) => {
    try {
      await axios.put(`${API}/api/admin/appointments/${id}/status?status=${status}`, {}, { withCredentials: true });
      toast.success('Durum güncellendi');
      fetchAppointments();
    } catch (err) {
      toast.error('Güncellenemedi');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Emin misiniz?')) return;
    try {
      await axios.delete(`${API}/api/admin/appointments/${id}`, { withCredentials: true });
      toast.success('Silindi');
      fetchAppointments();
    } catch (err) {
      toast.error('Silinemedi');
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Randevu Talepleri</h1>
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <table className="w-full text-left text-sm text-slate-600">
          <thead className="bg-slate-50 border-b border-slate-100 text-slate-500">
            <tr>
              <th className="px-6 py-3 font-medium">Hasta Adı</th>
              <th className="px-6 py-3 font-medium">Telefon</th>
              <th className="px-6 py-3 font-medium">Tarih</th>
              <th className="px-6 py-3 font-medium">Tedavi</th>
              <th className="px-6 py-3 font-medium">Not</th>
              <th className="px-6 py-3 font-medium">Durum</th>
              <th className="px-6 py-3 font-medium text-right">İşlem</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {appointments.map((apt) => (
              <tr key={apt.id} className="hover:bg-slate-50/50">
                <td className="px-6 py-4 font-medium text-slate-900">{apt.name}</td>
                <td className="px-6 py-4">{apt.phone}</td>
                <td className="px-6 py-4">{apt.date}</td>
                <td className="px-6 py-4">{apt.treatment}</td>
                <td className="px-6 py-4 max-w-xs truncate" title={apt.note}>{apt.note || '-'}</td>
                <td className="px-6 py-4">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                    apt.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                    apt.status === 'Approved' ? 'bg-green-100 text-green-800' :
                    'bg-slate-100 text-slate-800'
                  }`}>
                    {apt.status === 'Pending' ? 'Bekliyor' : apt.status === 'Approved' ? 'Onaylandı' : apt.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-right space-x-2">
                  {apt.status === 'Pending' && (
                    <button onClick={() => handleStatus(apt.id, 'Approved')} className="text-green-600 hover:text-green-700" title="Onayla" data-testid={`approve-${apt.id}`}>
                      <CheckCircle className="w-5 h-5 inline" />
                    </button>
                  )}
                  <button onClick={() => handleDelete(apt.id)} className="text-red-500 hover:text-red-700" title="Sil" data-testid={`delete-${apt.id}`}>
                    <Trash2 className="w-5 h-5 inline" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
